import classNames from "classnames";
import { isNotEmpty, isNotPresent, isPresent } from "neetocist";
import { Share, QrCode } from "neetoicons";
import { __, includes } from "ramda";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

import Card from "./Card";

const ShareBlock = ({
  moreOptions,
  disableShareSocialMedia,
  disableQRDownload,
  socialMediaProps,
  qrCodeProps,
  entity,
  urls,
}) => {
  const location = useLocation();
  const history = useHistory();

  const { t } = useTranslation();

  const handleNavigate = subPath => {
    // eslint-disable-next-line @bigbinary/neeto/use-common-routes
    history.push(`${location.pathname}/${subPath}`);
  };

  const hasMoreOptions = isPresent(moreOptions);

  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3",
        {
          "neeto-ui-border-gray-200 mt-8 border-t pt-8": isNotEmpty(urls),
        }
      )}
    >
      {hasMoreOptions &&
        moreOptions
          .filter(
            ({ permissions }) =>
              isNotPresent(permissions) ||
              globalProps.permissions.some(includes(__, permissions))
          )
          .map(
            ({
              title,
              link,
              icon: Icon,
              onClick,
              dataTestid,
              description,
              helpPopoverProps,
            }) => (
              <Card
                {...{
                  Icon,
                  description,
                  helpPopoverProps,
                  link,
                  onClick,
                  title,
                }}
                data-testid={dataTestid}
                key={link}
              />
            )
          )}
      {!disableShareSocialMedia && (
        <Card
          Icon={Share}
          data-testid="social-share-card"
          description={
            socialMediaProps?.cardDescription ||
            t("neetoMolecules.shareViaLink.socialMediaShare.description")
          }
          title={
            socialMediaProps?.cardTitle ||
            t("neetoMolecules.shareViaLink.socialMediaShare.title")
          }
          onClick={() => handleNavigate("social-media")}
        />
      )}
      {!disableQRDownload && entity && (
        <Card
          Icon={QrCode}
          data-testid="qr-code-card"
          description={
            qrCodeProps?.cardDescription ||
            t("neetoMolecules.shareViaLink.qrCode.description")
          }
          title={
            qrCodeProps?.cardTitle ||
            t("neetoMolecules.shareViaLink.qrCode.title")
          }
          onClick={() => handleNavigate("qrcode")}
        />
      )}
    </div>
  );
};

export default ShareBlock;
